<template>
    <div>
        <b-card no-body>
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span
                        >REGISTROS DE PAGAMENTOS APPSEBRAE - CONSULTORIAS</span
                    >
                    <div class="float-right">
                        <span class="text-primary">
                            <i
                                class="fa fa-refresh fa-lg icon-button"
                                title="Atualizar"
                                @click.stop="$emit('atualizar-listagem')"
                            ></i>
                        </span>
                    </div>
                </h4>
                <slot name="controles"></slot>
                <app-tabela
                    idTabela="tblPagamentos"
                    :itens="pagamentos"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false"
                >
                    <template slot="botoes">
                        <pagamento-inserir
                            :pagamentosServicos="pagamentosServicos"
                            @detalharPagamento="
                                $emit('detalhar-pagamento', $event)
                            "
                        ></pagamento-inserir>
                        <slot name="botoes"></slot>
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <slot name="acoes" v-bind="data"></slot>
                    </template>
                    <template slot="valorTotal" slot-scope="data">{{
                        data.valorTotal | currency
                    }}</template>
                </app-tabela>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import PagamentoInserir from './PagamentoInserir'

export default {
    props: {
        titulo: {
            type: String,
            default: () => 'PAGAMENTOS SGTEC'
        },

        pagamentos: {
            type: Array,
            default: () => []
        },

        pagamentosServicos: {
            type: Object,
            default: () => ({})
        },

        showFornecedor: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            campos: [
                {
                    key: 'protocolo',
                    label: 'Protocolo',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'fornecedor',
                    label: 'Fornecedor',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'qtdConsultorias',
                    label: 'Consultorias',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'qtdAnexos',
                    label: 'Anexos',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'valorTotal',
                    label: 'Valor Total',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'statusDescr',
                    label: 'Status',
                    type: 'status'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 0
        }
    },
    methods: {},

    created() {
        if (!this.showFornecedor) {
            this.campos.splice(1, 1)
        }
    },

    computed: {},

    watch: {},

    components: {
        PagamentoInserir
    }
}
</script>
